import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_TITLE = 'BRIZ.TV — онлайн телебачення, фільми та серіали 📺';
const DEFAULT_DESCRIPTION =
  'Дивись перші 14 днів за 1 грн улюблені ТВ-канали та фільми на TV, ПК чи смартфоні ⚡ BRIZ.TV  - Улюблений онлайн-кінотеатр вашої родини';

const normalizeMetaValue = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

export const usePageMeta = ({ title, description } = {}) => {
  const metaTitle = useMemo(() => {
    const normalizedTitle = normalizeMetaValue(title);

    if (!normalizedTitle) {
      return DEFAULT_TITLE;
    }

    return normalizedTitle;
  }, [title]);

  const metaDescription = useMemo(() => {
    const normalizedDescription = normalizeMetaValue(description);
    return normalizedDescription || DEFAULT_DESCRIPTION;
  }, [description]);

  return useMemo(
    () => (
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
    ),
    [metaDescription, metaTitle]
  );
};
